module.exports = __webpack_public_path__ + "img/tips-img-notorder.f7424b55.png";